import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const invisibleStyle = {
  opacity: 0,
};

export default class UserAvatar extends PureComponent {
  static propTypes = {
    alt: PropTypes.string.isRequired,
    onError: PropTypes.func,
    src: PropTypes.string.isRequired,
  };

  state = {
    loaded: false,
    error: false,
  };

  componentDidMount() {
    // Cached images won't fire onLoad action, so we need to do it manually
    if (this.imgLoaded()) {
      this.onLoad();
    }
  }

  imgLoaded = () => this.img && this.img.complete;

  imgLoadedSuccessfully = () => this.imgLoaded() && this.img.naturalWidth !== 0;

  onLoad = () => {
    if (!this.imgLoadedSuccessfully()) {
      this.onError();
      return;
    }

    this.setState({
      loaded: true,
    });
  }

  onError = () => {
    this.setState({
      loaded: true,
      error: true,
    });

    const { onError } = this.props;

    if (onError) {
      onError();
    }
  }

  render() {
    const { loaded, error } = this.state;

    if (loaded && error) {
      return null;
    }

    const { alt, src } = this.props;

    return (
      <img
        src={src}
        alt={loaded ? alt : ''}
        onLoad={this.onLoad}
        onError={this.onError}
        ref={img => { this.img = img; }}
        style={loaded ? null : invisibleStyle}
      />
    );
  }
}
